import db from '@/utils/db'

export const userDB = db('userDB', false)
